/* Bloc prix (Custom Liquid du modele produit) : pour les produits au m², la 2e ligne "Soit x € TTC / dalle(s)"
   n'est gardee que s'il existe un vrai equivalent (lot, module, palette...). Quand elle affiche le meme
   montant que le prix au m², elle n'apporte rien : masquee. Lignes prix au ml / a la piece non touchees. */
(function () {
  if (window.__mpnPkgLine) return; window.__mpnPkgLine = true;
  function txt(el) { return el ? el.textContent.replace(/\s+/g, '') : ''; }
  function check(box) {
    var line = box.querySelector('[data-package-price-line]');
    if (!line || line.hidden) return;
    if (!/\/(m(²|2)|sqm)$/i.test(txt(box.querySelector('[data-main-unit]')))) return;
    var a = txt(box.querySelector('[data-main-price]')), b = txt(box.querySelector('[data-package-price]'));
    if (a && a === b) line.hidden = true;
  }
  function init() {
    document.querySelectorAll('[id^="variant-price-summary-"]').forEach(function (box) {
      check(box);
      var line = box.querySelector('[data-package-price-line]');
      if (line && window.MutationObserver) new MutationObserver(function () { check(box); }).observe(box, { attributes: true, attributeFilter: ['hidden'], childList: true, characterData: true, subtree: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
